import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=3f0b787a&scoped=true&lang=pug"
import script from "./Restaurant.vue?vue&type=script&lang=js"
export * from "./Restaurant.vue?vue&type=script&lang=js"
import style0 from "./Restaurant.vue?vue&type=style&index=0&id=3f0b787a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0b787a",
  null
  
)

export default component.exports